export default {
	page_title: 'Kontaktní formulář',
	address_label: 'Adresa',
	address_part_1: 'Přední 2, 618 00 Brno–Černovice',
	address_part_2: 'Nová radnice, Dominikánské nám. 1, 601 67 Brno',
	mobile_label: 'Telefon',
	email_label: 'E-mail',
};
